import Appsignal from "@appsignal/javascript";

export const appsignal = new Appsignal({
  key: `${process.env.REACT_APP_APPSIGNAL_KEY}`,
  revision: "c68c18cdab5d69a5a1a721909595d63df2a74f7f",
});
